/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Weight_UnitInputs */

const en_attribute_weight_unit = /** @type {(inputs: Attribute_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight unit`)
};

/**
* | output |
* | --- |
* | "Weight unit" |
*
* @param {Attribute_Weight_UnitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_weight_unit = /** @type {((inputs?: Attribute_Weight_UnitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Weight_UnitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_weight_unit(inputs)
});